
import { defineComponent } from 'vue'

/**
 * Каркас страницы со списком: карточка, форма фильтра (слот filter),
 * пагинация сверху и снизу, контент (таблица) в слоте по умолчанию.
 */
export default defineComponent({
  name: 'PaymentListLayout',
  props: {
    page: { type: Number, default: 1 },
    pages: { type: Number, default: 1 },
    perPage: { type: Number, default: 20 },
    total: { type: Number, default: 0 },
  },
  emits: ['apply', 'reset', 'page-change'],
})
